import { createTheme, ThemeProvider, Slider } from '@mui/material';
import styles from './styles.module.css';
import { useState } from 'react';

const DEFAULT_MAX_VALUE = 50000;
const DEFAULT_MIN_VALUE = 50;
const DEFAULT_INITIAL_VALUE = 150;

const DEFAULT_STEP_1 = 50;
const DEFAULT_STEP_2 = 2000;
const DEFAULT_STEP_3 = 5000;

const RangeMoney = (props) => {
  const maxInputValue = props.max ?? DEFAULT_MAX_VALUE;
  const maxSlideValue = reverseCalculateValue(maxInputValue);

  const min = DEFAULT_MIN_VALUE;
  const max = maxSlideValue;
  const defaultValue = reverseCalculateValue(props.defaultValue ?? DEFAULT_INITIAL_VALUE);
  const [value, setPositionSlider] = useState(defaultValue);

  const [realValue, setRealValue] = useState(calculateValue(defaultValue));

  const theme = createTheme({
    palette: {
      primary: { main: props.wl.cor_tema_primaria },
      customColor: {
        main: '#b6b8b7',
        focus: props.wl.cor_tema_3,
      },
    },
  });

 async function updateValue({newInputValue, newSliderValue}) {
    let newValue;
    if(newInputValue > 0) {
      if(newInputValue[0] === '0') {
        newInputValue = newInputValue.slice(1);
      }
      setRealValue(newInputValue);
      setPositionSlider(reverseCalculateValue(newInputValue));
      newValue = newInputValue;
    } else if(newSliderValue > 0) {
      setRealValue(calculateValue(newSliderValue));
      setPositionSlider(newSliderValue);
      newValue = calculateValue(newSliderValue);
    } else {
      // reset
      setRealValue('0');
      setPositionSlider(0);
      newValue = 0;
    }

    if(props.handleUpdateValue) {      
     await props?.handleUpdateValue(newValue);
    }

}

  function reverseCalculateValue(value) {
    if (value <= DEFAULT_STEP_2) {
      return Math.round((value - DEFAULT_STEP_1) / 5);
    } else if (value <= DEFAULT_STEP_3) {
      return Math.round((value - DEFAULT_STEP_2) / DEFAULT_STEP_1) + 389;
    } else {
      return Math.round((value - DEFAULT_STEP_3) / 100) + 453;
    }
  }

  function calculateValue(value) {
    if (value <= 389) {
      return value * 5 + DEFAULT_STEP_1;
    } else if (value <= 699) {
      return (value - 389) * DEFAULT_STEP_1 + DEFAULT_STEP_2;
    } else {
      return (value - 453) * 100 + DEFAULT_STEP_3;
    }
  }

  const handlePosition = (e, newValue) => {
    updateValue({newSliderValue: newValue});
  };

  const handleChange = (e) => {
    var inputValue = e.target.value;
    inputValue = inputValue.substring(0, inputValue.length - 2);
    if (inputValue.startsWith('0')) {
      inputValue = inputValue.substring(1);
    }
    
    if (!inputValue) {
      inputValue = '0';
    }
    inputValue = inputValue.replace(/\D/g, '');

    if (inputValue > calculateValue(max)) {
      inputValue = maxInputValue;
    }
    
    updateValue({newInputValue: inputValue});

    setTimeout(() => {
      e.target.setSelectionRange(
        e.target.value.length - 3,
        e.target.value.length - 3
      );
    }, 1);
  };

  // const checkValue = () => {
 
  //   const _realValue = calculateValue(value);

  //   if (reverseCalculateValue(_realValue) < min) {
  //     updateValue({newInputValue: DEFAULT_MIN_VALUE})
  //   } else if (reverseCalculateValue(_realValue) > max) {
  //     updateValue({newSliderValue: max});
  //   }
  // };

  return (
    <>
      <ThemeProvider theme={theme}>
        
        <article className={styles['text-value']}>
          <p className="mobile__p5"> Valor da minha conta: </p>
          <h5 className="mobile__h5">
            <label>
              <input
                type="text"
                min={50}
                max={max}
                value={`R$ ${realValue},00`}
                // onKeyDown={(e) =>handleKeyUp(e)}
                onChange={handleChange}
                ref={props.ref}
                // onBlur={checkValue}
                onFocus={(e) => {
                  // updateValue({newSliderValue: 0});
                  setTimeout(() => {
                    e.target.setSelectionRange(
                      e.target.value.length - 3,
                      e.target.value.length - 3
                    );
                  }, 10);
                }}
              />
              <input type="hidden" name={props.name} value={realValue} />
            </label>
          </h5>
        </article>
        <div className={styles.slider}>
          <Slider
            size="small"
            sx={[
              {
                '&.MuiSlider-root': {
                  boxShadow: `0 0 0.5rem ${props.wl.cor_tema_botao_solido}`,
                  padding: '6px',
                  outline: 0,
                  background: 'var(--white-100)',
                },
                '& .MuiSlider-track': {
                  left: '-3px!important',
                  right: '-3px!important',
                  background: props.wl.cor_tema_3,
                  padding: '6px',
                  border: 'none',
                },
                '& .MuiSlider-rail': {
                  width: 'calc(100% - 10px)!important',
                  background: 'transparent',
                  left: '5px',
                  right: '5px',
                },

                '& .MuiSlider-valueLabel': {
                  background: 'transparent',
                  padding: '0',
                },
                '& .MuiSlider-thumb': {
                  left: (100 / maxSlideValue) * value + '%!important',
                },
              },
            ]}
            valueLabelDisplay="on"
            valueLabelFormat={() => {
              return (
                <svg
                  width="14"
                  height="24"
                  viewBox="0 0 14 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.98583 24L5.31916 14.6667H0.652497C0.319164 14.6667 0.113386 14.5778 0.0351638 14.4C-0.0421695 14.2222 0.00805255 13.9778 0.18583 13.6667L7.98583 0H9.31916L7.98583 9.33333H12.6525C12.9858 9.33333 13.1912 9.42222 13.2685 9.6C13.3467 9.77778 13.2969 10.0222 13.1192 10.3333L5.31916 24H3.98583Z"
                    fill={props.wl.cor_tema_primaria}
                  />
                </svg>
              );
            }}
            step={1}
            min={0}
            max={maxSlideValue}
            scale={calculateValue}
            defaultValue={defaultValue}
            value={value}
            onChange={handlePosition}
            color={theme.palette.customColor.pointerSlider}
          />
        </div>

      </ThemeProvider>
    </>
  );
};

export default RangeMoney;
